import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ValidationModalComponent } from '../popup/validation-modal/validation-modal.component';
import { coverageDTO } from '../models/coverageDTO';
import { NavaidDTOCalculation, NavaidModel, NavaidSitingToolModel } from '../models/navaid';
import { PerformanceDTO } from '../models/performanceDTO';
import { PerformanceAnalysisDTO } from '../models/performanceAnalysisDTO';
import { ConfigurationService } from './configuration.service';
import { PointsService } from './points.service';
import { UtilsService } from './utils.service';
import { Feature } from 'ol';
import { Geometry } from 'ol/geom';

@Injectable({
  providedIn: 'root'
})
export class ValidationModalService {

  constructor(private modalService : BsModalService, private configService: ConfigurationService, private pointsController: PointsService,
    private utilsService: UtilsService) { }

  async showModal(coverage: coverageDTO, performance: PerformanceDTO, sitingTool: NavaidSitingToolModel, invalidNavaids: NavaidModel[], ignoredNavaids: NavaidModel[],
                    calculationType: string, navaidsTerrainHeight: number[]) {
    const bsModalRef : BsModalRef = this.modalService.show(ValidationModalComponent);
    bsModalRef.content.coverage = coverage;
    bsModalRef.content.performance = performance;
    bsModalRef.content.sitingTool = sitingTool;
    bsModalRef.content.hasMaxAltitude = this.maxAltitudeCheckList(invalidNavaids);

    if (performance != null) {
      this.fillMaxAltitudeField(invalidNavaids, performance.navaids);
    } else if (coverage != null){
      this.fillMaxAltitudeField(invalidNavaids, coverage.navaids);
    } else {
      this.fillMaxAltitudeField(invalidNavaids, sitingTool.navaids);
    }
    if(invalidNavaids == null || invalidNavaids.length == 0){
      bsModalRef.content.activeIgnored = true;
      bsModalRef.content.activeInvalid = false;
      bsModalRef.content.fixMultiple = false;
    }
    else{
      bsModalRef.content.activeInvalid= true;
      bsModalRef.content.activeIgnored = false;
    }
    bsModalRef.content.invalidNavaids = invalidNavaids;
    bsModalRef.content.ignoredNavaids = ignoredNavaids;
    bsModalRef.content.calculationType = calculationType;

    if (invalidNavaids != null) {
      if (navaidsTerrainHeight) {
        invalidNavaids.forEach(n => {
          n.effectiveHeight = this.utilsService.metersToFeet(n.effectiveHeight);
        });
        bsModalRef.content.terrainElevation = navaidsTerrainHeight.map(h => this.utilsService.metersToFeet(h));
        bsModalRef.content.isPublishedElevation = true;
      } else {
        bsModalRef.content.terrainElevation = invalidNavaids.map(n => this.utilsService.metersToFeet(n.effectiveHeight));
      }
    }

    if(coverage && coverage.isCoverageAssessmentTool){
      bsModalRef.content.rangeLimitation = coverage.rangeLimitation;
    }else {
      bsModalRef.content.rangeLimitation = this.configService.currentConfiguration.calculation.rangeLimitation;
    }
  }
  async showPerformanceModal(performanceAnalysisDTO: PerformanceAnalysisDTO, invalidNavaids: NavaidModel[],
                              ignoredNavaids: NavaidModel[], calculationType: string, navaidsTerrainHeight: number[]) {
    const bsModalRef : BsModalRef = this.modalService.show(ValidationModalComponent);
    bsModalRef.content.hasMaxAltitude = this.maxAltitudeCheckList(invalidNavaids);
    bsModalRef.content.invalidNavaids = invalidNavaids;
    bsModalRef.content.performanceAnalysisDTO = performanceAnalysisDTO;
    this.fillMaxAltitudeField(invalidNavaids,performanceAnalysisDTO.navaids);

    bsModalRef.content.invalidNavaids = invalidNavaids;
    bsModalRef.content.ignoredNavaids = ignoredNavaids;
    bsModalRef.content.calculationType = calculationType;
    bsModalRef.content.rangeLimitation = this.configService.currentConfiguration.calculation.rangeLimitation
    if(invalidNavaids.length == 0){
      bsModalRef.content.activeIgnored = true;
      bsModalRef.content.activeInvalid = false;
    }
    else {
      if (navaidsTerrainHeight) {
        invalidNavaids.forEach(n => {
          n.effectiveHeight = this.utilsService.metersToFeet(n.effectiveHeight);
        });
        bsModalRef.content.terrainElevation = navaidsTerrainHeight.map(h => this.utilsService.metersToFeet(h));
        bsModalRef.content.isPublishedElevation = true;
      } else {
        bsModalRef.content.terrainElevation = invalidNavaids.map(n => this.utilsService.metersToFeet(n.effectiveHeight));
      }
      bsModalRef.content.activeIgnored = false;
      bsModalRef.content.activeInvalid = true;
    }
  }

  maxAltitudeCheckList(navaids: NavaidModel[]): boolean[]{
    const toReturn:  boolean[] = [];
    for (const nav of navaids){
      toReturn.push(this.utilsService.validPositiveNumber(nav.maxaltitude));
    };
    return toReturn;
  }

  async getNavaidsElevationList(navaids: NavaidModel[]): Promise<number[]> {
    const toReturn: number[] = [];
    for (const nav of navaids){
      toReturn.push(await this.getNavaidElevation(nav));
    };
    return toReturn;
  }

  async getNavaidElevation(navaid: NavaidModel): Promise<number>{
    return this.utilsService.metersToFeet(await this.pointsController.getNavaidElevationMeters(navaid));
  }

  fillMaxAltitudeField(invalidNavaids: NavaidModel[], navaids: NavaidDTOCalculation[]){
    for (const nav of invalidNavaids){
      if (nav.maxaltitude == null){
        nav.maxaltitude = this.configService.currentConfiguration.facilityConfiguration.docMaxAltitudeFT;
        nav.maxaltitudeMeters = this.utilsService.feetToMeters(nav.maxaltitude);
        const navaid_calculation: NavaidDTOCalculation = navaids.find((navaid: NavaidDTOCalculation) => navaid.dataBaseId == nav.id);
        navaid_calculation.maxaltitude = nav.maxaltitude;
        navaid_calculation.maxaltitudeMeters = nav.maxaltitudeMeters;
        navaid_calculation.maxOperationalFL = nav.maxaltitude/100;
      }
    }
  }
}
